import config from '../config';
import AxiosPromotion from '../services/promotion';
import { getDataFromSession } from '../utill.func';
import { CART_REQUEST, CART_SUCCESS, CART_FAILURE } from './types';

export const getCartData = (fields, cartId = undefined) => {
  return async (dispatch) => {
    const customer = getDataFromSession('customer');
    if (customer && customer?.type?.toLowerCase() === 'public') {
      return;
    };
    dispatch({ type: CART_REQUEST });
    try {
      let response = AxiosPromotion.get(
        `${config.API_URL}/promotion/cart`,
        {
          params: {
            fields,
            cartId: cartId ? decodeURIComponent(cartId) : cartId
          },
        },
      );
      const data = (await response)?.data?.data;
      dispatch({
        type: CART_SUCCESS,
        payload: data,
      });
      return data;
    } catch (error) {
      dispatch({
        type: CART_FAILURE,
        error: error.message,
      });
    }
  }
};

export const updateCartData = (newData) => async (dispatch) => {
  dispatch({
    type: CART_SUCCESS,
    payload: newData,
  });
}